<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-list-item :class="listItemClasses">
        <v-list-item-icon v-if="icon">
          <v-icon size="32">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
          <v-list-item-title>
            <v-select
              v-model="newValue"
              dense
              :placeholder="subtitle"
              :label="label"
              :rules="rules"
              :items="items"
              :item-value="selectItem.value"
              :item-text="selectItem.label"
              chips
              persistent
              clearable
              :disabled="isdisable"
              :menu-props="{ 'z-index': '1500 !important'}"
              required
              color="black"
              :return-object="returnObject"
              :multiple="multivalue"
              :error="haveError"
              :item-color="itemColor"
              @input="inputChange()"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: [String, Object, Array, Number],
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    isdisable: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default () {
        return [];
      }
    },
    listItemClasses: {
      type: String,
      default: ''
    },
    itemColor: {
      type: String,
      default: 'third'
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    },
    label: {
      type: String,
      default: null
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    multivalue: {
      type: Boolean,
      default: false
    },
    clearValue: {
      type: Boolean,
      default: true
    },
    haveError: {
      type: Boolean,
      default: false
    },
    selectItem: {
      type: Object,
      default: () => ({
        value: 'value',
        label: 'label'
      })
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    const inputChange = () => {
      context.emit('selectedInput', newValue.value);
    };

    return { newValue, inputChange };
  }
};
</script>
